import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsBoolean,
  IsIn,
  IsInt,
  IsObject,
  IsOptional,
  IsString,
  Min,
  MinLength,
  ValidateNested,
} from 'class-validator';
import type { AnswerValue } from '../../survey/survey-answers.types';
import { IMPORTED_ANSWER_CONFIDENCES, type ImportedAnswerConfidence } from './manual-import-status';

export class ImportedAnswerEvidenceDto {
  @IsInt()
  @Min(1)
  page!: number;

  @IsString()
  @MinLength(1)
  quote!: string;
}

export class ImportedAnswerProposalDto {
  /** `nodeId`, or `nodeId#iteration` for repeat-block inner nodes. */
  @IsString()
  @MinLength(1)
  answerKey!: string;

  @IsString()
  @MinLength(1)
  nodeId!: string;

  @IsObject()
  value!: AnswerValue;

  @IsIn(IMPORTED_ANSWER_CONFIDENCES)
  confidence!: ImportedAnswerConfidence;

  @IsBoolean()
  conflict!: boolean;

  @IsOptional()
  @IsArray()
  @IsObject({ each: true })
  alternatives?: AnswerValue[];

  @IsArray()
  @ArrayMaxSize(20)
  @ValidateNested({ each: true })
  @Type(() => ImportedAnswerEvidenceDto)
  evidences!: ImportedAnswerEvidenceDto[];
}

export type ImportedAnswerProposal = ImportedAnswerProposalDto;
